import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NavBar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-6">
            <h1 className="text-xl font-bold">ADA QR Cevap Sistemi</h1>
            <div className="flex space-x-4">
              <Link
                to="/dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/dashboard')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                Cevaplarım
              </Link>
              <Link
                to="/all-answers"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/all-answers')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                Tüm Cevaplar
              </Link>
              <Link
                to="/qr-scanner"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/qr-scanner')
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                QR Tara
              </Link>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-gray-700">Hoşgeldin, {user?.name}</span>
            <button
              onClick={logout}
              className="text-red-600 hover:text-red-800"
            >
              Çıkış
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
